/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'string',
      enum: [
        'FROM_0_TO_1',
        'FROM_2_TO_10',
        'FROM_11_TO_50',
        'FROM_51_TO_200',
        'FROM_201_TO_500',
        'FROM_501_TO_1000',
        'FROM_1001_TO_5000',
        'FROM_5001_TO_10000',
        'FROM_10001_TO_INFINITE',
      ],
      maxLength: 255,
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    company_size: valueSchema,
  },
}
